var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 308.3 95.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 25.25,
    width: 297.85,
    height: 61.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 25.25,
    width: 297.85,
    height: 61.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#luminosity-noclip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.23,75.69S243.69,88.17,297.85,25.25c-24.42,34-81.86,65-176,60.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,62.38s.53,3.16,4.28,2.26a39.07,39.07,0,0,1-6.64,3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,71.24s-.2,3.62,4.22,3-3.39,3.26-3.39,3.26S181,75.82,183.59,71.24Z"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1h") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62,86.82H5.79v2.1H2.62v4.31h4v2.1H.31V80.63h6.3v2.1h-4Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,80.63,14,87.77l2.58,7.56H14.19L12.3,89.51l-1.91,5.82H8.23l2.58-7.56L8.39,80.63h2.4L12.53,86l1.78-5.41Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,80.63a3.34,3.34,0,0,1,2.59.92,3.86,3.86,0,0,1,.85,2.71v1.91a3.86,3.86,0,0,1-.85,2.71,3.34,3.34,0,0,1-2.59.92H20.8v5.53H18.49V80.63Zm-1.1,2.1v5h1.1a1.13,1.13,0,0,0,.84-.29A1.58,1.58,0,0,0,23,86.32V84.11A1.58,1.58,0,0,0,22.74,83a1.13,1.13,0,0,0-.84-.29Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12,80.63h2.32v12.6h3.8v2.1H27.12Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.77,84.15a3.85,3.85,0,0,1,.9-2.74,3.44,3.44,0,0,1,2.61-1,3.43,3.43,0,0,1,2.6,1,3.85,3.85,0,0,1,.9,2.74V91.8a3.85,3.85,0,0,1-.9,2.74,3.39,3.39,0,0,1-2.6.95,3.4,3.4,0,0,1-2.61-.95,3.85,3.85,0,0,1-.9-2.74ZM37.08,92a1.59,1.59,0,0,0,.32,1.12,1.36,1.36,0,0,0,1.75,0A1.59,1.59,0,0,0,39.47,92V84a1.62,1.62,0,0,0-.32-1.13,1.36,1.36,0,0,0-1.75,0A1.62,1.62,0,0,0,37.08,84Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.82,95.33l-.09-.28c0-.08,0-.19-.07-.31s0-.29,0-.48,0-.45,0-.74V91.21a2.24,2.24,0,0,0-.36-1.45,1.43,1.43,0,0,0-1.15-.42h-.8v6H44V80.63h3.48A3,3,0,0,1,50.9,84v1.15a3,3,0,0,1-1.51,3,2.07,2.07,0,0,1,1.2,1.17,5.18,5.18,0,0,1,.33,2v2.27a9.09,9.09,0,0,0,0,1,3.27,3.27,0,0,0,.21.83ZM46.3,82.73v4.51h.9a1.49,1.49,0,0,0,1-.33,1.64,1.64,0,0,0,.37-1.22V84.24a1.88,1.88,0,0,0-.29-1.16,1.08,1.08,0,0,0-.89-.35Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,86.82h3.17v2.1H55.45v4.31h4v2.1h-6.3V80.63h6.3v2.1h-4Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,90.45,64.8,80.63h2.41L69,87.33l1.76-6.7H73L70,90.45v4.88H67.72Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.08,84.15a3.85,3.85,0,0,1,.9-2.74,4,4,0,0,1,5.21,0,3.85,3.85,0,0,1,.9,2.74V91.8a3.85,3.85,0,0,1-.9,2.74,4,4,0,0,1-5.21,0,3.85,3.85,0,0,1-.9-2.74ZM76.39,92a1.55,1.55,0,0,0,.33,1.12,1.14,1.14,0,0,0,.87.32,1.17,1.17,0,0,0,.87-.32A1.55,1.55,0,0,0,78.78,92V84a1.57,1.57,0,0,0-.32-1.13,1.21,1.21,0,0,0-.87-.32,1.18,1.18,0,0,0-.87.32A1.57,1.57,0,0,0,76.39,84Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,80.63V92a1.5,1.5,0,0,0,.33,1.11,1.2,1.2,0,0,0,.87.31,1.19,1.19,0,0,0,.87-.31A1.5,1.5,0,0,0,87.9,92V80.63h2.18V91.82a3.94,3.94,0,0,1-.87,2.74,3.92,3.92,0,0,1-5.14,0,3.89,3.89,0,0,1-.88-2.74V80.63Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,95.33c0-.1,0-.19-.08-.28a1.73,1.73,0,0,1-.08-.31c0-.13,0-.29,0-.48s0-.45,0-.74V91.21a2.24,2.24,0,0,0-.36-1.45,1.42,1.42,0,0,0-1.15-.42h-.8v6H92.37V80.63h3.49A3,3,0,0,1,99.28,84v1.15c0,1.51-.5,2.51-1.51,3A2.08,2.08,0,0,1,99,89.31a5.4,5.4,0,0,1,.32,2v2.27a9.09,9.09,0,0,0,0,1,3.27,3.27,0,0,0,.21.83Zm-2.52-12.6v4.51h.9a1.46,1.46,0,0,0,1-.33A1.6,1.6,0,0,0,97,85.69V84.24a1.89,1.89,0,0,0-.28-1.16,1.1,1.1,0,0,0-.9-.35Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,87.49l-.84,7.84h-3.17L105,80.63h2.25l1.24,11.59,1.11-11.59h2.23L113,92.3l1.2-11.67h2l-1.63,14.7h-3.07Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.19,95.33h-2.33l-.4-2.67h-2.83l-.4,2.67h-2.12l2.35-14.7h3.38Zm-5.27-4.67h2.23L121,83.23Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.11,90.45l-2.92-9.82h2.42l1.76,6.7,1.77-6.7h2.2l-2.92,9.82v4.88h-2.31Z",
    fill: "#e4833a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.89,47.13c-.63-4-1.22-7.69-1.83-11.59-.39.32-.69.56-1,.82a24.91,24.91,0,0,1-7.54,4.55,2.81,2.81,0,0,1-2.69-.22c-1.72-1.09-3.49-2.11-5.25-3.16a2.36,2.36,0,0,1,2.38-1,38.68,38.68,0,0,0,4.17.2,2,2,0,0,0,1.25-.41q7.31-6.18,14.55-12.43a6.64,6.64,0,0,1,4.61-1.66c1.51,0,2.14,1,1.5,2.36a6.53,6.53,0,0,1-1.45,1.9c-1.42,1.3-2.91,2.52-4.38,3.75a1.63,1.63,0,0,0-.66,1.25c-.32,4.11-.71,8.21-1,12.32a2.51,2.51,0,0,1-1.13,2.09C298.94,46.22,298.51,46.62,297.89,47.13Z",
    fill: "#1b7cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,29.89c1.13-1,1.92-2.23,3.73-2s3.71.3,5.56.43c.16,0,.31,0,.62.08-1.38,1.16-2.64,2.23-3.92,3.29a.62.62,0,0,1-.51.11q-2.55-.8-5.08-1.64C284.8,30.16,284.71,30,284.52,29.89Z",
    fill: "#1b7cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.32,35.6c.19-.13,0-.24,0-.29C286.05,35.58,286.37,35.63,286.32,35.6Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.76 38.29 283.76 38.18 283.46 38.69 283.76 38.29",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,40.4c.48.08,1-.76,1.55-1.06h.12l0-.4A8.65,8.65,0,0,1,281,40.4Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.08,40.85c.17,0-.25.33.37-.21h-.08Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,40.65c.28-.22-.26.05,0,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.06,41.7l.31-.38c-.13,0-.48.22-.39.08C277.63,41.74,277.75,41.75,278.06,41.7Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.84,42.17,278,42C278,42,277.89,42,277.84,42.17Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.37,41.59,278,42c.09,0,.16.09.17-.18C278.21,41.92,278.23,41.78,278.37,41.59Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.64,41.46c.27-.09.58-.26.26.12C279.61,41,279.36,40.88,278.64,41.46Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.1,40.8l.36-.13.18-.28C281.55,40.53,281,40.72,281.1,40.8Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,43.22c0,.08.25.08.33.14l.25-.26C275.9,43.15,275.58,43.3,275.5,43.22Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,43.36l-.37.4C275.86,43.51,275.9,43.41,275.83,43.36Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278 42.55 278.54 41.82 277.86 42.65 278 42.55",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.8 44.3 273.96 43.99 273.66 44.5 273.8 44.3",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,45.05c.11-.24-.39,0-.24-.25a3.45,3.45,0,0,0-.66.74A2.08,2.08,0,0,1,272.7,45.05Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,45.92a2,2,0,0,0,.31-.38A2.33,2.33,0,0,0,271.49,45.92Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.68,44.21a.63.63,0,0,0-.47,0l.29.06Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,44.32h0l-.38.24Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,44.18l-.05,0S274.72,44.22,274.73,44.18Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,43.18c-.2.27-.67.73,0,.54C276.81,43.48,276.45,43.59,276.75,43.18Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,44.27l.5-.27s-.17,0-.08-.18Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.89 44.47 275.09 44.27 274.9 44.37 274.89 44.47",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.41,45.59a2.74,2.74,0,0,1-.62.53,6.36,6.36,0,0,0,.85-.47C272.64,45.57,272.69,45.39,272.41,45.59Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.44,45l0,0S273.47,45,273.44,45Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.23 47.6 269.29 47.61 269.28 47.57 269.23 47.6",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,45.66a.79.79,0,0,0,.4-.35c-.14.11-.29.23-.46.34C272.64,45.69,272.64,45.71,272.7,45.66Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,46.42a2.62,2.62,0,0,0,.42-.11C271.11,46.32,270.84,46.35,270.83,46.42Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,45l0,0C273.24,45,273.26,45,273.3,45Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,45a1.68,1.68,0,0,0-.2.29,2.8,2.8,0,0,0,.3-.28Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.14,49.24c-.06-.2.4-.68,1-.77.4-.4-.24-.78-.83-.86,0,.08.07.15-.35.53.22,0,1.19-.4.88,0-.59.46-.56.24-.92.33.38.06-.64.79-.32,1l.5-.44C269.12,49.09,269,49.28,269.14,49.24Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.22,47.09l.18-.13a2.7,2.7,0,0,1-.82.16c-.28.28-.31.38-.3.45l1-.54Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,46.44c0,.27-.47.63-.06.66.57-.35.31-.39.61-.67-.91.59.21-.26-.53,0a2.83,2.83,0,0,1,.48-.34l-.54.19h0c.06,0,.08,0,0,0l0,0a.27.27,0,0,1,0,.09c-.3.12-.07,0,0-.09s0,0,0,0h0l-.88.65A5.86,5.86,0,0,0,271.29,46.44Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,44.42s-.05,0-.06,0S276.36,44.49,276.48,44.42Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,44.56a.55.55,0,0,1,.28-.3c.23-.07.06.09.11.14.1-.13.37-.43-.1-.25l-.05.07c-.41.17-1,.26-1,.19A1.67,1.67,0,0,0,276,44.56Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,45.58l-.7.58.48-.09-.08-.08C273.82,45.75,273.65,45.69,273.66,45.58Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.09 47.56 269.08 47.3 268.79 47.84 269.09 47.56",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.09 48.17 268.03 47.98 267.82 48.23 268.09 48.17",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.15,72.37l-.25.11A1.26,1.26,0,0,0,206.15,72.37Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,72l0-.1C208,72,208,72,208.06,72Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,60.07c-.42,0-.93-.17-.81,0l.19.16A1.6,1.6,0,0,1,241.84,60.07Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.28,67.21l.12,0,.2-.27Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24,68.14h-.53A2.28,2.28,0,0,0,223.24,68.14Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,74.54l-.27.27C196,74.72,195.73,74.65,195.75,74.54Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.44,53.74a3.6,3.6,0,0,0-.81.24C257,53.92,257.42,54,257.44,53.74Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,70c-.15.07-.21.12-.2.17S206.49,70,206.44,70Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,54.39l.18,0a3.19,3.19,0,0,1,.69-.38A1.27,1.27,0,0,0,255.76,54.39Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48,78.74l-.09,0S157.42,78.75,157.48,78.74Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,77l.46,0A1.54,1.54,0,0,0,146.21,77Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.9,50.34c.21-.13,0,0,0,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.37,50.54a.14.14,0,0,0,0,.14A.16.16,0,0,1,265.37,50.54Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,56.62h0C254.09,56.63,254.07,56.63,254,56.62Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.28,50.25a1.46,1.46,0,0,0-.32.1Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,50.19l.21-.09S264.36,50.05,264.18,50.19Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6,50.51a1.89,1.89,0,0,1,.36-.16s-.07,0-.06,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,76.31h-.06C177.66,76.42,177.77,76.39,178,76.31Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.4 64.32 236.42 64.3 236.38 64.31 236.4 64.32",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59,64.75a1,1,0,0,1,.79-.44l-.47-.51Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.59,73.33l.67.07c-.7.46-1.27.45-.63.61,0-.68,2.42-.51,2.38-1.21l.44.06c-.12,0-.13.06-.25.08.86.15.5-.61,1.54-.72.37,0,.64,0,.41.15l.77-.32c.23,0,.2.09,0,.12l1.2-.3v0a5.71,5.71,0,0,1,.69-.49c.33,0-.14.1,0,.17l.63-.31c.31.11-.21.41-.68.48.77.53.52-.29,2-.2l-.61.22c.49.29,1,0,1.72.12-.19-.09-1.56-.27-.87-.6a1.51,1.51,0,0,0,.86-.26c.05.24.42.1.9,0l0,.32c.5-.21.42-.36.7-.57a.89.89,0,0,1,.94.29c.94-.16-.73-.24.36-.55a5.61,5.61,0,0,0,2.18-.73c.56,0-.05.21.16.26l.42-.37c.12,0,.1.06.09.11.38-.2,0-.32.57-.56.08-.38,1.42.18,2.1-.4.21,0-.05.22,0,.32a7.59,7.59,0,0,0,1.66-1h.8c-.61-.08,0-.55.57-.93-.23-.06-.42-.12-.54-.14l.93-.42c.13,0,.06.15-.07.32l.16-.12c.38,0,.25.25,0,.49l-.4-.1c-.19.25-.36.52-.26.69a1,1,0,0,1,.3-.17c-.05.07-.08.12,0,.15s.12-.08.26-.2L224,68v-.15l1.34-.13a12.16,12.16,0,0,1,2.87-1.89c-.28.36,0,.44.11.74-.49-.2-1.08.47-1.85.61.4-.07.36.09.27.17l1.25-.68c0,.26.34.1.72.1-.41-.4.9-.61,1.4-.92.08.15,0,.35-.68.51.84.15.78-.84,1.59-.75-.16.06-.26.06-.3.16.34-.26,1.29-.42,1.12-.21l-.16,0c1.09-.24,3.25-1,3.28-1.47a2.27,2.27,0,0,1,0,.63l1.45-2c0,.4.86,1,0,1.5a2.49,2.49,0,0,0,1.1-.37c-.19,0-.6-.36-.37-.47a5.62,5.62,0,0,0,1.43.13c-.29,0-.18-.62.23-.75,0,.11.22.53.09.64l.82-.89c-.22.18.11.46.39.53-.14-.06.88-.3,1.13-.45l-.47,0c1.17-.32.86-1.14,2-1.52-.1.16-.1.8.5.66a5.48,5.48,0,0,1,1.6-2.3l.24.08.69-.47a13.49,13.49,0,0,1-1.93,2.55c.47,0,.19.14.82-.1.28.06-.27.34-.45.42.51-.14,1-.3,1.52-.47-.19-.28,1-.75.85-1l-1.48.95c-.18-.29.59-1.25,1.65-1.6.31,0,0,.63.08.73a2.42,2.42,0,0,1,1-.56l-.38.34c.63-.11.78-.78,1.6-.76.25-.07.88.12.85-.08a1.83,1.83,0,0,1-.91-1.64,15.75,15.75,0,0,1,1.74-.1c.5.11-.32.92.11,1,0-.09.16-.29.23-.36.28,0,0,.31.53,0,0-.36,1.12-.45.15-.38.49-.32.59-.18,1.2-.46-.28-.12.27-.93.76-1.24,0,.09.16.14.24.17,1.09-.45,1.75-.53,2.74-1,.13,0,.65-.11.5.12a1.57,1.57,0,0,1,.51-.44c.72,0-.67.36-.07.47,0-.2.68-.62,1.07-.94-.27-.22-1,.42-1.42.74-.18-.38.4-1.14,1.34-1.81.78-.48.48.08.59,0,1.58-.67,1-1.27,2.4-1.63.62,0,.26.46.46.58-.61.44-1.1.35-1.54.58l.61-.15a2,2,0,0,1-.87.5A6.43,6.43,0,0,0,262,53a17.45,17.45,0,0,1,2.2-1c.17-.19.49-.46.27-.46l-.36.22c-.44,0,.56-.63.05-.47a4.16,4.16,0,0,1,1.62-1.15l.27.2c-.05-.07-.54.08-.69.26.22-.27,1.27-.2,1.39-.71l-.59.06a5.86,5.86,0,0,1,1.52-1.28c-.42-.1-.12.11-.72,0,.59.19-1.57.84-.74.92-.65-.13-.86.25-1.61.25.06.08.29.06-.24.28a.39.39,0,0,1-.08.14h0s0,0,0,0a.63.63,0,0,1,.34,0c-.15.34-1,.76-1.2,1s.08-.17-.14-.18l-.34.38c-.14-.18-1,.1-.32-.4l-.65.33a3.56,3.56,0,0,0-1.28.56c-.33.11-.68.6-.48.31l-1,.62,0-.05c-1,.46-2,1.34-3.3,1.53a4.26,4.26,0,0,1-1.27.63l-.2-.13c-.42.26-1.43.41-1.54.68-.69-.28-2.23.83-3.06,1.09l.07.24a11.75,11.75,0,0,0-1.71.85l.12.19a16.55,16.55,0,0,1-2.51.84c0-.11.28-.18.47-.2-1.31,0-2.24,1.28-3.4,1.29a1.2,1.2,0,0,1-.62.22l.06,0-.11,0h-.4a2,2,0,0,0,.34,0,6.91,6.91,0,0,0-.76.36l-.2-.18-.07,0c-.32,0-.19.19,0,.31a2.52,2.52,0,0,0-.34.27c-.36-.28-.73.4-1.19.12-.13.26-1.42.68-1.45,1.13,0,0-.12,0,0-.11a2.08,2.08,0,0,0-.95.34L237,62.1l-.6.63c-.5,0-.71-.08-.35-.45-.94.69-.81.41-1.6,1v-.2c-.32.11-.76.53-1,.44-.82-.1-3.59,1-5.54,1.24.52.46-.93,0-.88.46-.15-.1-.43-.1-.16-.3-.91.41-1.49.18-2,.73-.15-.1.15-.25,0-.3s-.27.2-.39.14.11-.15.24-.24c-1,.28-1,.72-.92,1.12a1,1,0,0,0-1.07.39c-.21-.08-.53-.13.07-.34-.35.07-2.13.37-2.09.69a1,1,0,0,0-.56.16c-.78.17-.85.16-1.6.37h.22c-.2.45-.6.24-1.2.43v0c-1.47.07-.58.28-2,.3l.13.22c0,.53-1.29,0-2,.37L214,69c-.4.27-1.38-.41-1.83-.38-.11,0,.13-.1.26-.16-1.22,0-.08.34-.92.6-.2-.13.11-.47-.48-.37-.31-.07-1.56.91-2.41.77.2.09.4.18,0,.36-.61.17-1.76-.15-2.23.37-.09,0-.13,0-.14-.08a7.75,7.75,0,0,0-1.73.76c-.59-.71-2.84,1-3,.21l-1.44.3,0-.08a2.48,2.48,0,0,0-1.52.6c-.23,0-.08-.11-.07-.15a4.69,4.69,0,0,0-2.59.71l-.16-.22c-.28.19-2-.06-3.31.45a.22.22,0,0,1,.13-.14c-1.45.54-3.69-.13-4.11.85l-1,.37c1.29-.13-.14.41.41.48-.49.13-1.34-.07-.73-.21l.11,0c.16-.49-1.62.07-1.63-.26-2.53.37-5,.45-7.41.7l.32.33-.83.08c-.23-.06-.32-.25.27-.31-.34-.17-1,.29-1,.37-1.17,0,.4-.47,0-.44l-.48.09.11,0a1.83,1.83,0,0,1-1.1.42c-.46,0-.26-.2-.44-.19,0,0-.06,0-.27,0l-1,.08.45.24c-.45.19-1,.09-.47.36-.76-.41-3.91.23-4.37.11a6,6,0,0,1-2.06.37c.2,0,.35.36-.34.38.19-.69-1.29-.18-1.88-.62.52.28-1.94.24-1.13.63-.58,0,0-.25-.5-.37-1.34.37-3,.06-4.69.26,0,.09.27.21-.08.36l-.92-.38c-.33.06-.28.52-.9.26.09.06.22.17,0,.21-3.32-.23-6.74.72-10.12,0,.46.16.15.18-.19.2.22,0,0,.21.05.33l-1.42-.3c-.25.34-1.5,0-1.64.36l.44-.06c-.59.38.84.82.76,1.3.66-.43,1.78.59,2.86-.05.24.09-.21.17-.07.27a1.51,1.51,0,0,1,1.22-.19l-.06,0c1.74-.11,2.49.06,4.46.1l-.16-.23a2.11,2.11,0,0,1,.71.13c.47-.38-1.18,0-.76-.38.58.45,3-.14,3.37.38.65,0-.2-.26.44-.3l.18.14.15-.2c.43,0,.65.17.68.3a1.87,1.87,0,0,0-.4.07,8.82,8.82,0,0,0,1.74-.11l-.63,0a53.87,53.87,0,0,0,5.6-.66l-.14-.1c1.28-.31,1,0,2.47-.18l-.05,0a2.84,2.84,0,0,1,1-.24c-.35.16.7.19.24.38,1.39-.36.68-.24,1.57-.74l.23.16a1.7,1.7,0,0,1,1-.4c-.57.21.48.24-.15.51,1.53.26,2.17-.63,2.91-.12.64-.58-1.31-.14-.94-.29-.34-.13.52-.44,1-.44s.87.56,2.07.43c-.12,0-.12,0-.24.06.46.08.86-.27,1.43-.12.27-.35.72-.07.76-.48l-1.09.23a4.46,4.46,0,0,1,2.19-.61,1.89,1.89,0,0,1-.56.31c.31.08.56-.14.89-.06,0,.4-1.32.24-2,.62.35.13,1.23-.43,1,0,.41-.6,1.19-.07,1.95-.58l0,.24a2.13,2.13,0,0,1,.61-.22l-.39.36c.63-.34,1.3.08,1.91-.15-1.32.18-.33-.24-.91-.35,1.58-.52,1,.5,2.82.14-.25.07-1,0-.58-.17a3.57,3.57,0,0,1,1.05.12c1.2-.21-.21-.22.28-.43.45.23.57-.2,1.09-.36l0,.24c1.39,0,.29-.54,1.55-.54l-.48.41.63-.18-.09.29a3.3,3.3,0,0,1,1.59-.31c-.18-.15,0-.45.63-.55.44.08-.19.27.66.1a.61.61,0,0,1-.76.24c0,.08-.17.17-.2.26a4.47,4.47,0,0,0,1.44-.18,1,1,0,0,1-.35,0l1.2-.51c.21.06.06.15-.08.24.25-.06.4-.19.77-.27-.06.21,0,.4-.52.57l1.15-.4c.09.07.65.13.5.23.68,0,1.56-.65,2.45-.64a.63.63,0,0,1,.31-.16,6.6,6.6,0,0,0,2.51-.41l.61.24c.74-.22-.82-.3.42-.66.87-.27.38.23.71.27a3,3,0,0,1,2-.62A5.3,5.3,0,0,1,201.59,73.33Zm9.28-2c-.17.09-.49.32-.65.21C210.36,71.18,210.55,71.28,210.87,71.29Zm13.87-4a.72.72,0,0,1-.58.1A1.72,1.72,0,0,1,224.74,67.29Zm36.83-15.51v0C261.16,51.91,261.3,51.87,261.57,51.78Zm.79-.3c.06-.07,0-.09,0-.11s-.19.18-.39.26C262.05,51.66,262.17,51.65,262.36,51.48ZM175.11,75l.17,0C174.92,75.16,175,75.09,175.11,75Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25,68a.18.18,0,0,1-.11-.1C223.08,68,223.09,68,223.25,68Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,74.49h0s0,0,0,.05Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.27,58.83a.77.77,0,0,1-.36,0C250.93,58.91,251,58.93,251.27,58.83Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,49.05l-.45.31a1,1,0,0,1,.47-.16S266,49.13,266.13,49.05Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.94,48c.05-.07.14-.09.19-.16l-.07-.08C270.77,47.94,270.61,48.14,270.94,48Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,49.52c.14.15.4-.08.71-.3l-.06,0C267.56,49,267.26,49.23,267,49.52Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.73,49.17A2.38,2.38,0,0,1,268,49C268,48.87,267.9,49,267.73,49.17Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,50.87c.18,0,0-.28.11-.26C263.42,50.29,262.44,51.44,263.25,50.87Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.54 49.95 267.3 49.8 267.22 50.08 267.54 49.95",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.8,51.2l.57-.22s0-.09.11-.15C265.14,51,264.75,51.14,264.8,51.2Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.48,50.83a1.61,1.61,0,0,0,.41-.27A3.16,3.16,0,0,0,265.48,50.83Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.85 50.41 266.67 50.45 266.28 50.64 266.85 50.41",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.94,54.08l-.57.35c0,.11.16.08.37-.06S259.06,54.11,258.94,54.08Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.05,53.84a.63.63,0,0,1-.35-.05l.12.29Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,54.74c0,.1-.77.63,0,.25C259.34,54.89,259.91,54.54,259.33,54.74Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250 58.44 250.15 58.38 249.94 57.91 250 58.44",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.15,62.72c.79-.15.07-.36.8-.46.13-.17-.6.08-.45-.08C242.09,62.46,241.83,62.48,242.15,62.72Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,62.18l.2-.15A.87.87,0,0,0,242.5,62.18Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.36 76.8 143.86 76.7 144.19 76.87 144.36 76.8",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,77.19c0-.11-.07-.22-.11-.32l-.13.14-.07.07,0,0,0,0h0s0-.05,0,.06v.34l0-.38h.2A.26.26,0,0,1,143.4,77.19Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.39,71.62l0-.09c-.09-.06-.21,0-.45,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.59 72.81 205.71 72.8 205.43 72.55 205.59 72.81",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,74.27c.23,0,.49-.15.73-.18C200.2,74.23,199.84,73.92,200,74.27Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87,35.93c.18-.15,0-.24,0-.29C288.59,35.94,288.91,36,288.87,35.93Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.39 38.92 286.38 38.81 286.11 39.36 286.39 38.92",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73,41.37c.25,0,.49-.19.74-.46a3.59,3.59,0,0,1,.76-.79l.13,0,0-.41A9.42,9.42,0,0,1,283.73,41.37Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.75,42c.18,0-.24.36.37-.25l-.08,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,41.8c.28-.25-.27.07,0,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.75,43l.3-.42c-.13,0-.48.28-.39.13C280.31,43.08,280.44,43.08,280.75,43Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,43.5l.17-.21C280.66,43.29,280.6,43.33,280.55,43.5Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,42.85l-.35.44c.09,0,.17.08.17-.19C280.92,43.21,280.94,43.06,281.07,42.85Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.34,42.69c.27-.12.57-.32.27.1C282.31,42.14,282,42,281.34,42.69Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,41.77l.36-.16.17-.31C284.27,41.45,283.74,41.7,283.83,41.77Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,44.83c0,.08.26.06.35.11s.17-.19.24-.29C278.65,44.73,278.33,44.9,278.24,44.83Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.59,44.94l-.36.44C278.64,45.09,278.67,45,278.59,44.94Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.74 43.86 281.26 43.06 280.61 43.98 280.74 43.86",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.56 46.09 276.7 45.77 276.42 46.31 276.56 46.09",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.46,47c.1-.26-.4,0-.26-.22a3.17,3.17,0,0,0-.64.81A2.2,2.2,0,0,1,275.46,47Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,48a3.82,3.82,0,0,0,.29-.42A1.84,1.84,0,0,0,274.27,48Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,45.92A.61.61,0,0,0,277,46l.3,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.29,46.05h0l-.38.27Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5,45.88l0,0S277.5,45.92,277.5,45.88Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.51,44.65c-.18.3-.62.84,0,.56C279.6,44.94,279.24,45.1,279.51,44.65Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.88,45.93l.5-.31s-.18,0-.09-.19Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.69 46.16 277.88 45.93 277.69 46.05 277.69 46.16",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,47.53a2.84,2.84,0,0,1-.6.6,8.17,8.17,0,0,0,.84-.56C275.43,47.49,275.47,47.31,275.19,47.53Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.22,46.82l0,0S276.25,46.85,276.22,46.82Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.07 49.92 272.13 49.92 272.12 49.89 272.07 49.92",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,47.57a.81.81,0,0,0,.39-.39c-.14.13-.29.26-.46.39C275.43,47.61,275.44,47.63,275.5,47.57Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,48.57a2.85,2.85,0,0,0,.42-.17C273.92,48.43,273.65,48.5,273.64,48.57Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.08,46.87l0,0C276,46.85,276,46.87,276.08,46.87Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.08,46.87a2.59,2.59,0,0,0-.19.31,4,4,0,0,0,.29-.31Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.07,51.58c-.07-.19.37-.72,1-.87.38-.44-.3-.76-.92-.79,0,.09.08.15-.33.57.23,0,1.21-.52.91-.09-.59.52-.57.3-.94.42.41,0-.61.85-.27,1.06l.49-.49C272,51.43,271.88,51.64,272.07,51.58Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.06,49.32l.18-.16a2.81,2.81,0,0,1-.84.25c-.27.3-.3.41-.28.48l1-.64Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.11,48.53c0,.29-.43.71,0,.69.55-.44.29-.45.57-.78-.88.73.19-.29-.54.11a4.28,4.28,0,0,1,.46-.42,5.31,5.31,0,0,1-.53.27h0c.06,0,.08,0,0,0h0a.34.34,0,0,1,0,.1c-.29.16-.08,0,0-.1a0,0,0,0,0,0,0h0c-.28.26-.55.53-.85.76A4.06,4.06,0,0,0,274.11,48.53Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32,46s-.05,0-.06,0S279.21,46,279.32,46Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87,46.13a.64.64,0,0,1,.27-.33c.23-.09.07.08.12.13.1-.14.36-.46-.11-.24l0,.07c-.41.22-1.05.37-1,.29A1.6,1.6,0,0,0,278.87,46.13Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.49,47.4l-.7.66.5-.15-.09-.07C276.66,47.55,276.49,47.51,276.49,47.4Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.92 49.89 271.89 49.64 271.62 50.21 271.92 49.89",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.92 50.6 270.84 50.41 270.64 50.7 270.92 50.6",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,79.2l-.26.11Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.64,78.76l0-.11C209.59,78.72,209.56,78.77,209.64,78.76Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.47,65c-.44,0-1-.11-.84.07l.2.16A1.61,1.61,0,0,1,244.47,65Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,73.32l.13,0,.2-.28Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,74.26l-.56,0A2.24,2.24,0,0,0,225.41,74.26Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,81.62l-.28.27C197,81.8,196.77,81.73,196.79,81.62Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,57.29a4.21,4.21,0,0,0-.82.3C259.88,57.5,260.27,57.5,260.27,57.29Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,76.78c-.16.08-.22.13-.21.18C207.89,76.89,208,76.83,207.93,76.78Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.57,58.08l.18,0a5,5,0,0,1,.7-.44A1.4,1.4,0,0,0,258.57,58.08Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,85.71l-.09,0S156.64,85.72,156.7,85.71Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,83.69h.47A1.48,1.48,0,0,0,145,83.69Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,53.24c.21-.14,0,0,0,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.29,53.31a.15.15,0,0,0,0,.14A.17.17,0,0,1,268.29,53.31Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.92,60.53h0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.14,53.12l-.32.12Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,53.06l.2-.1S267.21,52.91,267,53.06Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.45,53.44a3.35,3.35,0,0,1,.37-.2c-.05,0-.08,0-.07,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17,83.53h0C177.86,83.63,178,83.61,178.17,83.53Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,69.66l0,0h0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.16,70.14a1,1,0,0,1,.82-.49l-.52-.48Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.9,80.28l.69,0c-.72.49-1.32.49-.65.63,0-.68,2.52-.61,2.47-1.29l.46,0c-.12,0-.14.06-.26.08.9.14.52-.61,1.61-.75.39,0,.67,0,.43.15l.8-.35c.24,0,.21.09,0,.13l1.25-.35v0a4.63,4.63,0,0,1,.71-.52c.34,0-.15.11,0,.17L211,78c.32.1-.22.41-.71.5.81.5.54-.31,2.05-.26l-.64.24c.51.27,1,0,1.81.07-.21-.08-1.65-.23-.93-.58a1.65,1.65,0,0,0,.9-.27c.06.23.44.08.94-.06l.05.32c.52-.22.43-.38.71-.6a.93.93,0,0,1,1,.24c1-.21-.76-.2.36-.57a6.43,6.43,0,0,0,2.27-.81c.58,0-.05.21.17.25l.43-.38c.13,0,.11.06.1.1.39-.21-.05-.32.58-.58.08-.37,1.48.12,2.18-.51.22,0,0,.22.05.32a8.77,8.77,0,0,0,1.7-1.08l.84,0c-.64-.06,0-.55.57-1l-.57-.11,1-.46c.14,0,.07.15-.06.32l.17-.12c.39,0,.26.23.05.48l-.42-.08c-.19.26-.36.54-.25.7a1.23,1.23,0,0,1,.3-.18c0,.07-.08.13,0,.15s.13-.08.28-.21l.33.27,0-.15c.46-.05.92-.13,1.38-.2a11.53,11.53,0,0,1,2.93-2.06c-.28.37.06.43.14.73-.51-.18-1.11.51-1.91.71.41-.1.37.07.28.15l1.29-.74c0,.25.36.08.75.06-.43-.38.92-.66,1.43-1,.09.15,0,.36-.68.55.88.1.79-.87,1.62-.84-.16.06-.26.07-.3.17.34-.28,1.32-.51,1.15-.29l-.16.06c1.12-.35,3.35-1.22,3.36-1.68a2,2,0,0,1,0,.64c.48-.7,1-1.37,1.44-2.07,0,.41.93,1,.1,1.51a2.54,2.54,0,0,0,1.12-.47c-.19,0-.63-.31-.4-.44a6,6,0,0,0,1.48,0c-.29,0-.21-.62.21-.77,0,.11.25.51.12.63l.83-.95c-.22.2.13.46.42.52-.15-.06.91-.36,1.16-.52l-.49,0c1.21-.4.86-1.18,2-1.66-.1.17-.06.81.55.62a5.46,5.46,0,0,1,1.54-2.46l.26.07.69-.52a16.64,16.64,0,0,1-1.88,2.71c.48-.08.2.12.84-.18.29,0-.26.37-.45.46l1.56-.59c-.21-.27,1-.82.84-1.05l-1.5,1.05c-.2-.27.56-1.29,1.65-1.72.32,0,0,.64.11.73a2.6,2.6,0,0,1,1.06-.63l-.38.37c.65-.16.79-.83,1.62-.89.25-.11.91,0,.87-.18a1.76,1.76,0,0,1-1-1.56,12.1,12.1,0,0,1,1.78-.27c.54.07-.27.94.18,1,0-.09.14-.3.22-.38.29,0,0,.31.55,0-.06-.35,1.14-.53.13-.39.5-.35.61-.22,1.24-.55-.3-.1.22-1,.72-1.3,0,.09.18.13.26.15,1.1-.57,1.75-.75,2.76-1.31.13,0,.66-.15.53.09a1.53,1.53,0,0,1,.5-.49c.74-.07-.67.42,0,.48-.06-.19.67-.68,1.05-1-.29-.19-1.05.51-1.43.86-.21-.37.35-1.18,1.29-1.92.78-.55.5,0,.62-.1,1.58-.83.93-1.41,2.35-1.92.64-.07.3.45.51.55-.61.49-1.1.47-1.55.75l.62-.22a2.29,2.29,0,0,1-.85.61c.54-.05,2.6-1.54,3.9-2.07.16-.2.47-.5.25-.49l-.36.26c-.46,0,.54-.68,0-.48a5.47,5.47,0,0,1,1.6-1.33l.29.17c-.06-.06-.54.15-.68.36.21-.3,1.27-.36,1.36-.91l-.59.15a5.24,5.24,0,0,1,1.47-1.46c-.44-.07-.12.12-.74.12.61.11-1.55,1-.7,1-.67-.06-.84.38-1.63.44.08.08.32,0-.23.31a.94.94,0,0,1-.06.15h0s0,0,0,0a.76.76,0,0,1,.35,0c-.13.35-1,.85-1.18,1.13s.07-.18-.16-.17l-.32.41c-.16-.17-1,.18-.36-.37l-.66.39a3.28,3.28,0,0,0-1.28.69c-.34.14-.66.69-.48.37-.32.25-.63.51-1,.74l0,0c-1.05.55-2,1.5-3.35,1.8a4.94,4.94,0,0,1-1.27.77l-.2-.1c-.41.31-1.44.56-1.55.83-.74-.22-2.28,1-3.13,1.32l.08.25a12.3,12.3,0,0,0-1.71,1l.14.18c-.51.48-1.62.57-2.57,1,0-.11.28-.2.48-.23-1.36.06-2.27,1.43-3.46,1.56a1.2,1.2,0,0,1-.63.28l.06,0-.11,0-.41.06a1.83,1.83,0,0,0,.35,0c-.19.1-.49.25-.77.43l-.22-.17-.07,0c-.33,0-.19.2,0,.3a2.59,2.59,0,0,0-.34.3c-.39-.26-.74.44-1.23.2-.13.26-1.46.75-1.47,1.21,0,0-.13,0,0-.1a2.13,2.13,0,0,0-1,.42l-.26-.23-.59.68c-.51,0-.74,0-.38-.41-1,.74-.83.45-1.63,1.13l0-.2c-.33.12-.77.57-1,.49-.87-.09-3.67,1.32-5.72,1.59.56.43-1,0-.91.5-.15-.09-.44-.08-.17-.3-.94.46-1.54.28-2.09.87-.16-.09.14-.26,0-.31s-.28.22-.4.18.11-.16.24-.27c-1,.36-1,.78-.92,1.18a1.12,1.12,0,0,0-1.11.44c-.22-.07-.55-.11.06-.35-.36.09-2.21.46-2.16.78a1.14,1.14,0,0,0-.58.19c-.8.22-.88.21-1.65.47h.23c-.2.46-.62.27-1.24.48v0c-1.52.12-.59.3-2.11.38l.15.21c0,.53-1.35,0-2.13.46l.33,0c-.41.29-1.44-.33-1.91-.29-.12,0,.14-.1.27-.17-1.28,0-.08.34-1,.63-.2-.13.11-.47-.5-.36-.33-.06-1.61,1-2.51.84.21.08.42.16,0,.36-.63.2-1.83-.06-2.32.47-.09,0-.13-.05-.14-.08a8.17,8.17,0,0,0-1.8.8c-.62-.72-3,1-3.11.29-.5.13-1,.23-1.5.34l0-.08a2.65,2.65,0,0,0-1.58.63c-.24,0-.09-.11-.08-.16a4.85,4.85,0,0,0-2.69.78l-.17-.22c-.29.21-2.12,0-3.46.49,0,0,0-.08.14-.14-1.52.57-3.86-.06-4.3.91l-1,.37c1.35-.13-.14.42.43.49-.52.13-1.41-.07-.76-.21l.11,0c.17-.5-1.7.08-1.71-.24-2.64.38-5.25.47-7.73.72l.32.33-.87.07c-.23-.06-.33-.25.29-.3-.35-.17-1,.29-1,.37-1.23,0,.43-.48.06-.45l-.51.09.12,0a2.13,2.13,0,0,1-1.15.42c-.48,0-.27-.2-.45-.2,0,0-.07,0-.29,0l-1.1.07.47.25c-.47.19-1,.08-.49.36-.79-.43-4.1.21-4.57.07a6.67,6.67,0,0,1-2.17.35c.21,0,.36.36-.36.37.21-.68-1.34-.19-2-.64.54.29-2,.21-1.2.61-.6,0-.05-.25-.51-.38-1.41.36-3.15,0-4.91.18,0,.09.28.21-.1.36l-.94-.4c-.35,0-.31.51-.95.23.09.07.23.18,0,.21-3.46-.3-7.06.55-10.57-.29.47.17.16.19-.21.19.24,0,0,.21,0,.33L144,83.66c-.27.33-1.57,0-1.73.3l.46,0c-.63.35.85.85.75,1.32.7-.4,1.83.66,3,.06.26.1-.21.16-.08.27a1.66,1.66,0,0,1,1.29-.16l-.07,0c1.82,0,2.61.15,4.66.24l-.16-.23a2.17,2.17,0,0,1,.75.15c.5-.37-1.24,0-.79-.4.6.47,3.11-.07,3.52.46.68,0-.21-.27.47-.29l.18.14.17-.19c.44,0,.67.19.69.31a3.53,3.53,0,0,0-.42.06,8.11,8.11,0,0,0,1.83-.07l-.66-.06a56.56,56.56,0,0,0,5.88-.56l-.15-.1c1.35-.29,1.1.06,2.59-.13l-.05,0a2.92,2.92,0,0,1,1.09-.24c-.37.16.73.19.25.38,1.45-.34.71-.23,1.65-.72l.24.16a1.88,1.88,0,0,1,1.08-.38c-.6.2.5.24-.17.5,1.6.27,2.29-.62,3.06-.09.67-.58-1.38-.16-1-.31-.35-.13.56-.43,1.05-.43s.91.58,2.17.45c-.13,0-.13,0-.26.06.49.08.9-.28,1.5-.13.29-.35.75-.07.8-.47l-1.14.22a4.76,4.76,0,0,1,2.3-.6,1.93,1.93,0,0,1-.6.31c.33.08.6-.14.94-.06-.05.4-1.39.24-2.05.62.35.13,1.29-.43,1,0,.45-.6,1.25-.07,2.05-.57l0,.24a2.37,2.37,0,0,1,.64-.22l-.41.36c.66-.34,1.35.06,2-.17-1.38.19-.35-.24-.95-.34,1.66-.53,1,.49,2.94.13-.25.07-1,0-.6-.17a3.93,3.93,0,0,1,1.1.12c1.26-.21-.22-.22.29-.43.47.23.61-.19,1.15-.37l0,.24c1.46-.06.31-.55,1.63-.56l-.5.41.66-.18-.1.29a3.49,3.49,0,0,1,1.67-.32c-.19-.15,0-.45.66-.55.45.08-.21.26.69.09a.66.66,0,0,1-.8.24c0,.09-.18.18-.21.26a4.24,4.24,0,0,0,1.5-.19.87.87,0,0,1-.36,0l1.25-.54c.22,0,.07.15-.08.25.26-.07.42-.21.81-.3-.07.21,0,.41-.55.59l1.21-.42c.09.07.67.12.52.22.71,0,1.63-.66,2.56-.66a.75.75,0,0,1,.32-.16,7.64,7.64,0,0,0,2.63-.49l.64.24c.77-.23-.86-.29.43-.67.91-.29.41.23.75.26a3.36,3.36,0,0,1,2.08-.67A5.7,5.7,0,0,1,202.9,80.28Zm9.66-2.34c-.17.1-.51.34-.68.23C212,77.85,212.23,77.94,212.56,77.94ZM227,73.34a.75.75,0,0,1-.6.13A1.77,1.77,0,0,1,227,73.34ZM264.42,54.9v0C264,55.06,264.14,55,264.42,54.9Zm.8-.37c.06-.08,0-.1,0-.11s-.19.19-.39.29C264.91,54.73,265,54.71,265.22,54.53Zm-90,27.69.17,0C175,82.38,175.12,82.3,175.22,82.22Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.41,74.15a.18.18,0,0,1-.11-.1C225.23,74.11,225.25,74.16,225.41,74.15Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.85,81.57h0s0,0,0,.05Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.17,63a.91.91,0,0,1-.37,0C253.81,63.06,253.91,63.07,254.17,63Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,51.69l-.43.37a1.4,1.4,0,0,1,.46-.22S268.81,51.8,269,51.69Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,50.17c.05-.07.14-.11.19-.18l-.08-.07C273.68,50.12,273.53,50.33,273.86,50.17Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.82,52.07c.15.14.41-.11.72-.37l-.06,0C270.42,51.44,270.12,51.75,269.82,52.07Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.61,51.64c.1-.07.2-.15.3-.21S270.77,51.5,270.61,51.64Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,53.83c.19,0,0-.28.1-.27C266.25,53.24,265.3,54.48,266.11,53.83Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.46 52.45 270.2 52.32 270.13 52.61 270.46 52.45",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,54l.58-.27s0-.1.09-.16C268.08,53.78,267.68,54,267.74,54Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,53.59a1.71,1.71,0,0,0,.41-.32C268.73,53.33,268.54,53.48,268.41,53.59Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.78 53 269.6 53.06 269.22 53.3 269.78 53",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.85,57.51l-.57.39c0,.11.17.07.38-.09S262,57.53,261.85,57.51Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,57a.72.72,0,0,1-.36,0l.14.28Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3,58.13c0,.11-.77.7,0,.26C262.32,58.28,262.89,57.88,262.3,58.13Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.83 62.67 252.99 62.59 252.74 62.14 252.83 62.67",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9,67.63c.82-.2.07-.35.81-.51.13-.19-.61.13-.47-.05C244.83,67.38,244.56,67.41,244.9,67.63Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,67.07a1,1,0,0,0,.21-.17Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.06 83.38 142.53 83.26 142.87 83.44 143.06 83.38",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,83.73l-.12-.33-.33.28C141.71,83.67,142,83.65,142,83.73Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.16,78.23l0-.08c-.1-.07-.22,0-.47,0Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.06 79.65 207.19 79.63 206.9 79.39 207.06 79.65",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,81.25c.25,0,.52-.15.77-.19C201.45,81.21,201.06,80.9,201.2,81.25Z",
    fill: "#398dcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75,20.5l-.89-.45,2.6,3.88A43.48,43.48,0,0,1,19.91,8C32.75-.8,45,7,53.26,18.1l-1-2.38-.8.59,2.07,1.55c-7-9.34-17.77-20.36-30.6-15.81C14.74,5,8.15,12.9,4.27,20.44c-.64,1.25,2.91,4.28,3.08,3.94A43.88,43.88,0,0,1,19.92,9.3C32.38.19,44.29,7.79,52.45,18.69c.24.32,1.52,2,2.07,1.56l.81-.59c.55-.4-.84-2.17-1-2.39C47.15,7.7,36.28-3.26,23.15.91,14.38,3.71,7.46,12,3.38,20,2.81,21.12,5.1,23.43,6,23.87l.89.45C7.93,24.85,5.77,21,4.75,20.5Z",
    fill: "#1b7cc5"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,74.77a8.17,8.17,0,0,1-1.92-.25,3.58,3.58,0,0,1-1.7-1,2.89,2.89,0,0,1-.8-2v-.13c.09-2.23.14-5,.14-8.48q0-2.58,0-5.61Q.27,48.26,0,43.1v-.25a3.83,3.83,0,0,1,1-2.62c.93-1,2.49-1.58,4.7-1.58h.11a5.78,5.78,0,0,1,3.42.94,3.38,3.38,0,0,1,1.47,2.56c.09,1.32.14,3.11.14,5.39,0,1,0,2.05,0,3.2q-.06,5.71-.26,11.55c-.14,3.89-.3,6.87-.46,8.95A3.29,3.29,0,0,1,9,73.5c-.7.72-2,1.14-3.89,1.27ZM10,33.43A3.2,3.2,0,0,1,8.61,36a5.35,5.35,0,0,1-3.19,1.06,4.4,4.4,0,0,1-3.2-1.43,4.8,4.8,0,0,1-1.36-3,3.54,3.54,0,0,1,1.45-2.72,5.38,5.38,0,0,1,3.3-1.17,3.92,3.92,0,0,1,3.06,1.56A5.55,5.55,0,0,1,10,33.43Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,64.65l1.47.78a1.6,1.6,0,0,1,.81,1,2.28,2.28,0,0,1,.05.44,1.68,1.68,0,0,1-.27.89,16,16,0,0,1-3.59,4A12.93,12.93,0,0,1,33,74.63a11.27,11.27,0,0,1-2.78-.33q-5.34-1.5-6.67-6a36.75,36.75,0,0,1-1.47-9.92q0-1.44,0-2.94c0-3,.1-6,.31-9.14H16.75a1.58,1.58,0,0,1-1.15-.48,1.56,1.56,0,0,1-.49-1.16V43.07a1.61,1.61,0,0,1,.49-1.18,1.55,1.55,0,0,1,1.15-.49H22.7c.07-1.09.13-2,.17-2.64a5,5,0,0,1,1.4-3.58,4.92,4.92,0,0,1,3.57-1.28h.58a6.63,6.63,0,0,1,2.4.39,4.49,4.49,0,0,1,1.6,1,4.44,4.44,0,0,1,1.45,3.22c0,.73,0,1.7-.14,2.92h6.58a1.55,1.55,0,0,1,1.17.49A1.63,1.63,0,0,1,42,43.07v1.64a1.62,1.62,0,0,1-1.64,1.64h-7Q33,50,32.89,54.74c0,.7,0,1.39,0,2.08a59.22,59.22,0,0,0,.41,6.92c.28,2.29.93,3.88,1.95,4.75a1.06,1.06,0,0,0,.28.17,1.27,1.27,0,0,0,.39,0h.34a3,3,0,0,0,.85-.22,11.06,11.06,0,0,0,3.22-3.25,1.65,1.65,0,0,1,1-.72,1.31,1.31,0,0,1,.41-.06A1.86,1.86,0,0,1,42.48,64.65Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,33.46a3.41,3.41,0,0,1-1.42,2.77,5.77,5.77,0,0,1-3.42,1.13,4.67,4.67,0,0,1-3.42-1.53,5.09,5.09,0,0,1-1.46-3.26,3.78,3.78,0,0,1,1.55-2.91,5.79,5.79,0,0,1,3.54-1.25,4.2,4.2,0,0,1,3.27,1.67A5.79,5.79,0,0,1,59,33.46Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,37.87q2.5,2.76,3.61,8.2a68.88,68.88,0,0,1,1.28,12q.06,2.09.06,4.11c0,2.95-.09,5.84-.25,8.67a4.71,4.71,0,0,1-.81,2.58A2.9,2.9,0,0,1,96,74.5a4.62,4.62,0,0,1-1.23.24h-.09l-3.36-.06h-.14a4.88,4.88,0,0,1-1-.13,2.76,2.76,0,0,1-1.22-.75,2.8,2.8,0,0,1-.66-1.31,4.76,4.76,0,0,1-.06-.72,2,2,0,0,1,0-.36l0-.2c.09-1.67.13-3.37.13-5.11,0-2.09-.08-4.68-.26-7.75A70.8,70.8,0,0,0,87,49.3C86.49,46.35,85.8,44.57,85,44a2.51,2.51,0,0,0-.89.61,43.25,43.25,0,0,0-4.61,9.62,92.79,92.79,0,0,0-3,10.27,36.49,36.49,0,0,0-1,6v.08h0v.14a4,4,0,0,1-3.61,4H70.43a6,6,0,0,1-3.61-1.06A3.14,3.14,0,0,1,65.37,71q0-8.89-.25-19.72C65,45.86,65,42.08,65,39.87a4.77,4.77,0,0,1,1.33-3.58A4.94,4.94,0,0,1,69.9,35h.56a6.7,6.7,0,0,1,2.61.46,4.8,4.8,0,0,1,1.64,1.1,4,4,0,0,1,1.16,2.83c0,.15,0,.29,0,.42q-.22,3-.23,9.31v1.44a53.11,53.11,0,0,1,3-6.35,25.49,25.49,0,0,1,3.55-5q3.19-3.33,6.75-3.36A6.31,6.31,0,0,1,93.57,37.87Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,61.24l1.14.89a1.68,1.68,0,0,1,.62,1,2.45,2.45,0,0,1,0,.27,1.65,1.65,0,0,1-.25.87c-.68,1.16-1.46,2.35-2.33,3.55a22.26,22.26,0,0,1-3,3.34,13.86,13.86,0,0,1-3.72,2.47,11.23,11.23,0,0,1-4.69.94,17.35,17.35,0,0,1-6-1.22,12.8,12.8,0,0,1-6.08-5.18,21.21,21.21,0,0,1-2.92-8.1,30.16,30.16,0,0,1-.33-4.44,29.39,29.39,0,0,1,.36-4.59q1.22-7.08,5-11.21a12.93,12.93,0,0,1,9.25-4.4h.64A12.49,12.49,0,0,1,125,37.05a7.78,7.78,0,0,1,3.57,4.77,11.15,11.15,0,0,1,.28,2.41q0,5-4.92,9.48a25.76,25.76,0,0,1-5.14,3.48A15.41,15.41,0,0,1,113.52,59a16,16,0,0,0,2.58,8.5,4.29,4.29,0,0,0,3.56,1.89,6.65,6.65,0,0,0,2.39-.5,10,10,0,0,0,3.79-3.13,25.86,25.86,0,0,0,2.57-3.95,1.47,1.47,0,0,1,1.06-.81,1.84,1.84,0,0,1,.33,0A1.58,1.58,0,0,1,130.74,61.24ZM121.6,48.1a7.29,7.29,0,0,0,1.64-4.31,4.67,4.67,0,0,0-.14-1.19,3,3,0,0,0-1.25-1.81,3.61,3.61,0,0,0-1.11-.14h-.57a3.37,3.37,0,0,0-1.48.68,7.87,7.87,0,0,0-2.11,2.43,25.1,25.1,0,0,0-2.81,9.92,14.49,14.49,0,0,0,3.71-1.79A16,16,0,0,0,121.6,48.1Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.89,39.59a15,15,0,0,1,3,7.37,19,19,0,0,1,.23,2.94,22.62,22.62,0,0,1-.9,6.2,4,4,0,0,1-1.75,2.36,3.92,3.92,0,0,1-2.19.64,4.2,4.2,0,0,1-.69-.06l-2.87-.47a4.06,4.06,0,0,1-3.39-4,4.26,4.26,0,0,1,.31-1.53,10.45,10.45,0,0,0,.64-3.58,17.35,17.35,0,0,0-.43-3.2,5.73,5.73,0,0,0-2-3.36,1.08,1.08,0,0,0-.75-.33H156a2.07,2.07,0,0,0-1.11.5,18.91,18.91,0,0,0-4.46,7.58,42.21,42.21,0,0,0-2.1,10.72q0,5.5-.19,9.2-.39,3.5-3.64,4l-.11,0h-1.31a5.91,5.91,0,0,1-3.62-1.07A3.16,3.16,0,0,1,138,70.85q0-8.86-.25-19.67-.16-8-.17-11.34a4.55,4.55,0,0,1,4.95-4.91h.41a6.93,6.93,0,0,1,2.75.47,4.54,4.54,0,0,1,1.67,1.11,4,4,0,0,1,1.2,2.86,2.56,2.56,0,0,1,0,.39c-.1.89-.16,2.17-.2,3.84a17.72,17.72,0,0,1,4.53-5.23,11.59,11.59,0,0,1,6.11-2.3l.59,0A9.23,9.23,0,0,1,166.89,39.59Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,64.65l1.47.78a1.6,1.6,0,0,1,.81,1,1.72,1.72,0,0,1,.06.44,1.69,1.69,0,0,1-.28.89,15.84,15.84,0,0,1-3.59,4,12.93,12.93,0,0,1-7.94,2.81,11.33,11.33,0,0,1-2.78-.33q-5.34-1.5-6.67-6A36.75,36.75,0,0,1,218,58.43q0-1.44,0-2.94c0-3,.1-6,.31-9.14h-5.61a1.6,1.6,0,0,1-1.16-.48,1.55,1.55,0,0,1-.48-1.16V43.07a1.6,1.6,0,0,1,.48-1.18,1.57,1.57,0,0,1,1.16-.49h5.94c.07-1.09.13-2,.17-2.64a5,5,0,0,1,1.4-3.58,4.92,4.92,0,0,1,3.57-1.28h.58a6.73,6.73,0,0,1,2.41.39,4.58,4.58,0,0,1,1.6,1,4.47,4.47,0,0,1,1.44,3.22c0,.73,0,1.7-.14,2.92h6.59a1.53,1.53,0,0,1,1.16.49,1.59,1.59,0,0,1,.47,1.18v1.64a1.62,1.62,0,0,1-1.63,1.64h-7q-.3,3.69-.44,8.39c0,.7,0,1.39,0,2.08a57.13,57.13,0,0,0,.42,6.92c.27,2.29.92,3.88,1.94,4.75a.87.87,0,0,0,.67.22h.35a3,3,0,0,0,.84-.22,11.21,11.21,0,0,0,3.23-3.25,1.63,1.63,0,0,1,1-.72,1.4,1.4,0,0,1,.41-.06A1.86,1.86,0,0,1,238.4,64.65Z",
    fill: "#1b304f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.35,61.24l1.14.89a1.66,1.66,0,0,1,.61,1,1.24,1.24,0,0,1,0,.27,1.65,1.65,0,0,1-.25.87c-.69,1.16-1.46,2.35-2.33,3.55a22.83,22.83,0,0,1-2.95,3.34,13.86,13.86,0,0,1-3.72,2.47,11.27,11.27,0,0,1-4.7.94,17.26,17.26,0,0,1-6-1.22,12.8,12.8,0,0,1-6.08-5.18,21,21,0,0,1-2.92-8.1,30.16,30.16,0,0,1-.33-4.44,29.39,29.39,0,0,1,.36-4.59q1.22-7.08,5-11.21a12.92,12.92,0,0,1,9.25-4.4h.64a12.43,12.43,0,0,1,6.51,1.62,7.75,7.75,0,0,1,3.58,4.77,11.13,11.13,0,0,1,.27,2.41q0,5-4.91,9.48a26.05,26.05,0,0,1-5.14,3.48A15.41,15.41,0,0,1,253.13,59a16,16,0,0,0,2.58,8.5,4.28,4.28,0,0,0,3.56,1.89,6.69,6.69,0,0,0,2.39-.5,10,10,0,0,0,3.79-3.13A25.86,25.86,0,0,0,268,61.77a1.48,1.48,0,0,1,1.05-.81l.34,0A1.58,1.58,0,0,1,270.35,61.24ZM261.21,48.1a7.35,7.35,0,0,0,1.64-4.31,5.17,5.17,0,0,0-.14-1.19,3,3,0,0,0-1.25-1.81,3.71,3.71,0,0,0-1.11-.14h-.57a3.44,3.44,0,0,0-1.49.68,8,8,0,0,0-2.11,2.43,25.1,25.1,0,0,0-2.8,9.92,14.49,14.49,0,0,0,3.71-1.79A16.13,16.13,0,0,0,261.21,48.1Z",
    fill: "#1b304f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.48,24H54.7c.43.07.87.11,1.29.21a9.1,9.1,0,0,1,6.94,10.65,16.46,16.46,0,0,1-1.79,4.8,33.24,33.24,0,0,1-6.27,7.89,6.55,6.55,0,0,1-.59.45h-.37a4.09,4.09,0,0,1-.52-.38,34.87,34.87,0,0,1-4.8-5.5,20.44,20.44,0,0,1-3-5.9,9.49,9.49,0,0,1,.18-6.56,8.84,8.84,0,0,1,6.18-5.38C52.45,24.14,53,24.09,53.48,24Z",
    fill: "none",
    stroke: "#1b7cc5",
    strokeMiterlimit: 10,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28,50.5h-.37a4.09,4.09,0,0,1-.52-.38,35.24,35.24,0,0,1-4.57-5.19c.14,3.23.24,7.35.3,12.39q0,3,0,5.61c0,3.43,0,6.25-.14,8.48v.13a2.89,2.89,0,0,0,.8,2,3.58,3.58,0,0,0,1.7,1,8.23,8.23,0,0,0,1.92.25h.38c1.89-.13,3.19-.55,3.89-1.27a3.29,3.29,0,0,0,1.09-2.26c.16-2.08.32-5.06.46-8.95s.22-7.74.26-11.55c0-1.15,0-2.22,0-3.2s0-2,0-2.81a35.54,35.54,0,0,1-4.64,5.32A6.55,6.55,0,0,1,54.28,50.5Z",
    fill: "#1b7cc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,66.11V60l.34-.21a.77.77,0,0,0,.34-.63h0V53.57L202.06,50a.75.75,0,0,0,0-1.06l-2.25-2.25a.75.75,0,0,0-1.06,0l-.69.69-1.82-3.05a.75.75,0,0,0-.65-.37h-.08V41.81a2.39,2.39,0,0,0-.71-1.71,2.41,2.41,0,0,0-1.71-.72,2.38,2.38,0,0,0-1.12.28.38.38,0,0,0,.08-.47l-.88-1.52a.37.37,0,0,0-.51-.13.38.38,0,0,0-.13.51l.87,1.51a.36.36,0,0,0,.44.17,2.33,2.33,0,0,0-.46.37,2.53,2.53,0,0,0-.58.91l-.49-.73a.91.91,0,0,0-.17-.17l-1.27-7h0a.75.75,0,1,0,0-1.49h-.13a1.21,1.21,0,0,0,.91-1.17c.07-1-1.07-2.25-1.58-2.82l0,0a.74.74,0,0,0-1-.05l-.06.06h0c-.51.57-1.65,1.83-1.58,2.82a1.21,1.21,0,0,0,.91,1.17h-.13a.75.75,0,1,0,0,1.49h.62V38a.75.75,0,0,0,1.49.12l.58,3.25-1.17,2.85a.75.75,0,0,0,.1.75h0l1.11,1.39-1,1.52a.72.72,0,0,0,0,.82h0l1,1.49-1.06,1.93,0,.05-3.08-3.42h0l-.05-.05a.74.74,0,0,0-1.05,0L179,53.79l-1.78-2h0s0,0-.05-.05a.74.74,0,0,0-1,0l-4,4.32a.75.75,0,0,0,1.09,1l3.46-3.72,5.39,6a.74.74,0,0,0,1.11-1L180,54.9l4.27-4.59,2.73,3c.21.23.54.45.54.75V68.2a.74.74,0,0,0,.72.74v1.47a20.34,20.34,0,0,1-9.34-6.47,20.4,20.4,0,0,1-3.54-6.5.76.76,0,0,0-.94-.48.75.75,0,0,0-.48.94,21.86,21.86,0,0,0,21.58,15A21.94,21.94,0,0,0,207,69.15a.75.75,0,0,0-.85-1.24,20.44,20.44,0,0,1-8.39,3.32V68.85c1.2-1.8,2.22-3.45,3.07-5h8.21c.87,1.62,1.92,3.3,3.15,5.15a.75.75,0,0,0,1,.2.74.74,0,0,0,.2-1c-1-1.54-1.92-3-2.69-4.32h.56a.75.75,0,1,0,0-1.5H210a30.33,30.33,0,0,1-2.31-5.8c-.06-.24-.13-.48-.19-.72h.45a.75.75,0,0,0,0-1.5h-.77a48.56,48.56,0,0,1-.62-10.52h.53a.75.75,0,1,0,0-1.49h-1.34V38.42a.75.75,0,1,0-1.49,0v3.87h-1.34a.75.75,0,1,0,0,1.49h.53a48.56,48.56,0,0,1-.62,10.52H202a.75.75,0,0,0,0,1.5h.44l-.18.72a30.33,30.33,0,0,1-2.31,5.8h-1.37a.75.75,0,0,0,0,1.5h.56c-.42.74-.88,1.5-1.37,2.29Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,71.4c-.28,0-.57,0-.85,0a19.9,19.9,0,0,1-5.73-.6V68l5.94-4.42a.73.73,0,0,0,.16-1,.68.68,0,0,0-.26-.22h0l-.76-.4,1.49-1V71.4Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85,48.81l-.41-.59,1-1.5a.74.74,0,0,0,0-.91l-1.17-1.47.78-1.89,1.8,2.61a.74.74,0,0,0,.59.32l2.79.06,1.8,3-2.24,2.24a.75.75,0,0,0,0,1.06L197,54h0v4.76l-4,2.57a.74.74,0,0,0-.32.31.75.75,0,0,0,.32,1l.85.44L189,66.71V53.21l.22-.39,3.11-5.24a.74.74,0,0,0-1.28-.76l-1.19,2Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,40.83a.37.37,0,0,1-.51-.14.37.37,0,0,1,.14-.5l1.52-.88a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.5l-1.52.88Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.81,39.56a.37.37,0,0,1-.5.14.37.37,0,0,1-.14-.51l.88-1.52a.36.36,0,0,1,.5-.13.37.37,0,0,1,.14.51l-.88,1.51Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.35,39a.37.37,0,0,1-.38.37.36.36,0,0,1-.37-.37V37.2a.37.37,0,0,1,.37-.38.38.38,0,0,1,.38.38V39Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.16,43V41.81a.93.93,0,0,1,.28-.66.9.9,0,0,1,.65-.27.91.91,0,0,1,.65.27.93.93,0,0,1,.28.66v2.12l-1.22,0-.64-.93Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.47 49.47 197.51 52.43 196.31 51.24 199.28 48.27 200.47 49.47 200.47 49.47",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52,29.23c.34.42.68.88.66,1.11,0,.05-.15-.08-.59-.11a.24.24,0,0,0-.12,0c-.46,0-.61.16-.61.11,0-.23.31-.69.66-1.11Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,68.56a.75.75,0,0,1-1.5,0,2.82,2.82,0,1,0-5.63,0,.75.75,0,0,1-1.5,0,4.32,4.32,0,1,1,8.63,0Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,55.8c-.09.37-.18.74-.29,1.11a30.47,30.47,0,0,1-2.07,5.41h6.65a31.31,31.31,0,0,1-2.08-5.41c-.1-.37-.19-.74-.28-1.11Z",
    fill: "#d8a744",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.22,58.84h-.49a9.23,9.23,0,0,1-.93,2.51h2.35a9.23,9.23,0,0,1-.93-2.51Z",
    fill: "#1b304f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,43.78h-.13a51.07,51.07,0,0,1-.59,10.52h1.31A51.07,51.07,0,0,1,205,43.78Z",
    fill: "#d8a744",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,52.14A19.47,19.47,0,0,1,185.18,34.2",
    fill: "none",
    stroke: "#1b304f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,58.79V54h0l-2.25-2.25a.75.75,0,0,1,0-1.06L197,48.47l-1.8-3-2.79-.06a.74.74,0,0,1-.59-.32L190,42.45l-.78,1.89,1.17,1.47a.74.74,0,0,1,0,.91l-1,1.5.41.59,1.19-2a.74.74,0,0,1,1.28.76l-3.11,5.24-.22.39v13.5l4.83-3.59-.85-.44a.75.75,0,0,1-.32-1,.74.74,0,0,1,.32-.31Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,63.61,189.72,68v2.82a19.9,19.9,0,0,0,5.73.6c.28,0,.57,0,.85,0V61l-1.49,1,.76.4h0a.68.68,0,0,1,.26.22A.73.73,0,0,1,195.66,63.61Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,43.9l1.22,0V41.81a.93.93,0,0,0-.28-.66.91.91,0,0,0-.65-.27.9.9,0,0,0-.65.27.93.93,0,0,0-.28.66V43Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 49.51,
    width: 4.19,
    height: 1.69,
    transform: "translate(22.51 155.04) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,30.23c.44,0,.59.16.59.11,0-.23-.32-.69-.66-1.11-.35.42-.68.88-.66,1.11,0,.05.15-.08.61-.11A.24.24,0,0,1,187.59,30.23Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,59.16V54.4h0l-2.25-2.25a.75.75,0,0,1,0-1.06L197,48.84l-1.8-3-2.79-.06a.74.74,0,0,1-.59-.32L190,42.82l-.78,1.89,1.17,1.47a.74.74,0,0,1,0,.91l-1,1.5.41.59,1.19-2a.74.74,0,0,1,1-.26.75.75,0,0,1,.26,1l-3.11,5.24-.22.39v13.5l4.83-3.59-.85-.44a.75.75,0,0,1-.32-1,.74.74,0,0,1,.32-.31Z",
    fill: "#afefd8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,64l-5.94,4.42v2.82a19.9,19.9,0,0,0,5.73.6c.28,0,.57,0,.85,0V61.37l-1.49,1,.76.4h0a.68.68,0,0,1,.26.22A.73.73,0,0,1,195.66,64Z",
    fill: "#96edcc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,44.27l1.22,0V42.18a.93.93,0,0,0-.28-.66.91.91,0,0,0-.65-.27.9.9,0,0,0-.65.27.93.93,0,0,0-.28.66v1.16Z",
    fill: "#afefd8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 49.88,
    width: 4.19,
    height: 1.69,
    transform: "translate(22.24 155.14) rotate(-45)",
    fill: "#afefd8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.59,30.6c.44,0,.59.16.59.11,0-.23-.32-.69-.66-1.11-.35.42-.68.88-.66,1.11,0,.05.15-.08.61-.11A.24.24,0,0,1,187.59,30.6Z",
    fill: "#f4c542",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.23,50.31,180,54.9,181,56l3.26-2.59,3.28,2.18c0-1.63.32-1.32-.54-2.27Z",
    fill: "#efba95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.05 58.35 176.61 53.42 173.62 56.63 176.4 55.04 181.05 58.35",
    fill: "#efba95",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2787575af945b750765d114e7f156e80.svg";
export { ForwardRef as ReactComponent };